
import { useEffect, useState } from 'react';

import { sponsorService } from 'services/sponsor.service';
const useSponsorRequest = (payload = { skip: 0, limit: 3 }) => {
  const [data, setData] = useState()

  const getSponsorRequesterList = async () => {
    const response = await sponsorService.sponsorRequesterList(payload)
    setData(response?.data?.data)
  }
  useEffect(() => {
    getSponsorRequesterList()
  }, [payload?.limit])

  return { sponsorData: data };
}
export default useSponsorRequest